// extracted by mini-css-extract-plugin
export var buttonClose = "CouponCodeField_buttonClose__8ngBd";
export var closeIcon = "CouponCodeField_closeIcon__seGVw";
export var couponSelector = "CouponCodeField_couponSelector__hPazi";
export var titleCorrect = "CouponCodeField_titleCorrect__TIio5";
export var wrapper = "CouponCodeField_wrapper__FesNZ";